var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"absolute right-0 bottom-0",attrs:{"fill":"currentColor","aria-hidden":"true","viewBox":"0 0 100 100","xlmns":"http://www.w3.org/2000/svg"}},[_c('polygon',{attrs:{"points":"100,0 100,100 0,100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }